import { useEffect, useRef } from 'react';

const useSkipMountEffect = (effect, deps) => {
  const skip = useRef(true);

  useEffect(() => {
    if (skip.current) {
      skip.current = false;
      return;
    }

    effect();
  }, deps);
};

export default useSkipMountEffect;
